import React, { useEffect, useState } from 'react';
import acm from '../AddCarModal.module.css'
import Mobile from "../../../../../assets/Icon/Mobile";
import At from "../../../../../assets/Icon/At";
import Time from "../../../../../assets/Icon/Time";
import Id from "../../../../../assets/Icon/Id";
import Client from "../../../../../assets/Icon/User";
import { useClient } from '../../../../../hooks/useClient';
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import { max } from 'moment';
import { useTranslation } from 'react-i18next';
import { baseFileURL } from '../../../../../Api';

const AddClientForm = ({ newCar, setNewCar, validates }) => { 
    const { t } = useTranslation();
 
    const { clientService } = useClient(10);

    const [searchClients, setSearchClient] = useState([]) 

    const [selectedClient, setSelectedClient] = useState(  newCar.client ? newCar.client : {} )

    const [client, setClient] = useState({
        id: 0,
        firstname: "",
        lastname: "",
        personal: "",
        email: "",
        password: "",
        mobile: "", 
    });

    useEffect(() => {
        
        if (newCar.client) {
            setNewCar(prevState => ({
                ...prevState,
                client_id: newCar.client.id
            }));
        } 

      }, []);

    const handleClientChange = async (event) => {

        let val = event.target.value;
        setClient(prevClient => ({
            ...prevClient,
            [event.target.name]: val
        }));

        var searchedLength = 0

        if (val.length > 10) {
            const tempClient = { ...client, [event.target.name]: val };
 
            setNewCar(prevState => ({
                ...prevState,
                client_id: 0,
                client: tempClient
            }));

            var resultClients = await clientService.search(tempClient, 5)

            if (resultClients && resultClients.clients && resultClients.clients.length > 0) {
                setSearchClient(resultClients.clients)
                searchedLength = 1
            } else {
                setSearchClient([])
                searchedLength = 0 
            }
           
            setNewCar(prevState => ({
                ...prevState,
                searchedClients: searchedLength,
            })); 
        } else {
            if (searchClients.length > 0) {
                setNewCar(prevState => ({
                    ...prevState,
                    searchedClients: 1,
                }));
            }
        } 

    };


    const handlePhoneChange = (phone) => {
        let val = phone;
        setClient(prevClient => ({
            ...prevClient,
            ["mobile"]: val
        }));

        if (val.length > 0) {
            const tempClient = { ...client, ["mobile"]: val };
            setNewCar(prevState => ({
                ...prevState,
                client_id: 0,
                client: tempClient
            })); 
        }
    };

    const handleClientClick = (idx) => {
        setSelectedClient(searchClients[idx])
        setNewCar(prevState => ({
            ...prevState,
            client_id: searchClients[idx].id,
            searchedClients: 0,
            client:  {}
        })); 
  
        setSearchClient([]) 
    };

    const cancelHandle = () => {
        setSelectedClient({})
        setSearchClient([])
        setNewCar(prevState => ({
            ...prevState,
            client_id: 0, 
            client_id: 0, 
        }));
        resetClient()
    };

    function resetClient() {
        setClient({
            id: 0,
            firstname: "",
            lastname: "",
            personal: "",
            email: "",
            password: "",
            mobile: ""
        });
    }



    return (
        <div>
            {newCar.client_id === 0 ? (
                <fieldset className={acm.formField}>
                    <legend>{t('Client')}</legend>
                    
                    <div className={acm.inp2col} style={{ marginBottom: 0 }}>
                      
                        <div className={acm.groupInput}>
                            <div className={acm.groupInputIcon}>
                                <input type="textS" 
                                    className={validates && validates.personal ? acm.input + ' ' +  acm.errorInput : acm.input  } 
                                    placeholder={t('PersonalNumber')} name="personal" value={client.personal} onChange={handleClientChange} autoComplete="off"
                                    onInput={(e) => {
                                        e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();
                                    }}
                                />
                                <div className={acm.crmIcon}>
                                    <Id />
                                </div>
                            </div>
                            {validates && validates.personal &&
                                <div className={ acm.errorMsg } >{validates.personal.message}</div>}
                        </div>
 
  
                        <div  className={validates && validates.mobile ? acm.groupInput + ' errorInput'  : acm.groupInput}>
                            <PhoneInput
                                defaultCountry={baseFileURL === 'https://crm.autonomo.kz' ? 'kz' : 'ge'}
                                value={client.mobile} 
                                hideDropdown={false}
                                name="mobile"  
                                onChange={(phone) => handlePhoneChange(phone)}
                            />
 
                            {validates && validates.mobile &&
                            <div className={ acm.errorMsg } >{validates.mobile.message}</div>}
                        </div>



                    </div>
   
                    <div className={acm.inp2col}>

                        <div className={acm.groupInput}>
                            <div className={acm.groupInputIcon}>
                                <input type="textS" 
                                    className={validates && validates.firstname ? acm.input + ' ' +  acm.errorInput : acm.input  } 
                                    placeholder={t('Firstname')} name="firstname" value={client.firstname} onChange={handleClientChange} autoComplete="off"
                                    onInput={(e) => {
                                        e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();
                                    }}
                                     />
                                <div className={acm.crmIcon}>
                                    <Client />
                                </div>
                            </div>
                        </div>

                        <div className={acm.groupInput}>
                            <div className={acm.groupInputIcon}>
                                <input type="textS"
                                    className={validates && validates.lastname ? acm.input + ' ' +  acm.errorInput : acm.input } 
                                    placeholder={t('Lastname')} name="lastname" value={client.lastname} onChange={handleClientChange} autoComplete="off" 
                                    onInput={(e) => {
                                        e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();
                                    }}
                                />
                                <div className={acm.crmIcon}>
                                    <Client />
                                </div>
                            </div>
                        </div>
                    </div>
 
                    <div className={acm.groupInput}>
                        <div className={acm.groupInputIcon}>
                            <input type="textS" 
                                className={validates && validates.email ? acm.input + ' ' +  acm.errorInput : acm.input  } 
                                placeholder={t('Email')} name="email" value={client.email} 
                                onChange={handleClientChange} 
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/[^A-Za-z0-9.@\-_]/g, '').toUpperCase();
                                }}   
                                autoComplete="off" />
                            <div className={acm.crmIcon}>
                                <At />
                            </div>
                        </div>
                    </div>


                    {searchClients && searchClients.length > 0 && (
                        <div style={{ width: '100%', position: 'relative' }} >
                                 
                            <div className={validates && validates.searchedClients ? acm.searchClient + ' ' +  acm.errorInput : acm.searchClient }  >
                                {validates && validates.searchedClients &&
                                    <span style={{ color: 'rgb(225, 29, 72)' , background: '#fff', fontSize: '10px', position: 'absolute', top: '-6px', right: '7px', lineHeight: '1'}} >{validates.searchedClients.message}</span>
                                }
                                {searchClients.map((client, index) => (
                                    <div key={index} onClick={() => handleClientClick(index)}>{client.firstname} {client.lastname} ({client.personal})</div>
                                ))}
                            </div>
 
 
                        </div>
                    )}

 
                </fieldset>
            ) : (
                <fieldset className={acm.formField}>
                    <legend>{t('Client')}</legend>
     

                    <div className={acm.inp2col} >

                        <div className={acm.groupInput}>
                            <div className={acm.groupInputIcon}>
                                <input type="textS" className={acm.input} placeholder={t('PersonalNumber')} name="personal" value={selectedClient.personal} readOnly />
                                <div className={acm.crmIcon}>
                                    <Id />
                                </div>
                            </div>
                        </div>

                        <div className={acm.groupInput}>

                            <PhoneInput
                                defaultCountry="ge"
                                value={selectedClient.mobile} 
                                hideDropdown={false}
                                disabled={true}
                                
                                name="mobile" 
                            />

                            <div className={acm.groupInputIcon}  style={{display: 'none'}}>
  
                                <input type="textS" className={acm.input} placeholder={t('Phone')} name="mobile" value={selectedClient.mobile} readOnly />
                                <div className={acm.crmIcon}>
                                    <Mobile />
                                </div>
                            </div>
                        </div>
 
                    </div>
                    
                    <div className={acm.inp2col}>

                        <div className={acm.groupInput}>
                            <div className={acm.groupInputIcon}>
                                <input type="textS" className={acm.input} placeholder={t('Firstname')} name="firstname" value={selectedClient.firstname} readOnly />
                                <div className={acm.crmIcon}>
                                    <Client />
                                </div>
                            </div>
                        </div>

                        <div className={acm.groupInput}>
                            <div className={acm.groupInputIcon}>
                                <input type="textS" className={acm.input} placeholder={t('Lastname')} name="lastname" value={selectedClient.lastname} readOnly />
                                <div className={acm.crmIcon}>
                                    <Client />
                                </div>
                            </div>
                        </div>

                    </div>
 
 

                    <div className={acm.groupInput}>
                        <div className={acm.groupInputIcon}>
                            <input type="textS" className={acm.input} placeholder={t('Email')} name="email" value={selectedClient.email} readOnly />
                            <div className={acm.crmIcon}>
                                <At />
                            </div>
                        </div>
                    </div>

                    <div className={acm.selectedClientReset} onClick={() => cancelHandle()}>
                        <Time />
                    </div>

 
                </fieldset>
            )}
        </div>
    );
};

export default AddClientForm;